import { useEffect, useState } from "react"
import { listenSeasonRecoveryLessons } from "../utils/firestore.utils"

// Le lezioni del circolo che contano per i recuperi (`tracksRecovery`), dal
// primo giorno della stagione in poi: le assenze da recuperare non stanno in
// un mese, una di settembre può restare aperta fino a primavera.
//
// L'ultima lettura di ogni circolo resta qui, finché l'app è aperta: la
// scheda che si rifà da capo (tornando sul profilo, uscendo dal riordino,
// riaprendo il foglio del sostituto) parte da quella, invece che vuota e poi
// allungata quando arriva la lettura nuova.
const lastRead = new Map()
const cacheKey = (schoolID, seasonStart) => `${schoolID}|${seasonStart.getTime()}`

// `null` finché non si sa: non è "nessuna assenza"
const useSeasonRecoveryLessons = (schoolID, seasonStart) => {
	const key = schoolID && seasonStart ? cacheKey(schoolID, seasonStart) : null
	const [lessons, setLessons] = useState(() => (key && lastRead.get(key)) ?? null)

	useEffect(() => {
		setLessons((key && lastRead.get(key)) ?? null)
		if (!key) return
		return listenSeasonRecoveryLessons(schoolID, seasonStart, read => {
			lastRead.set(key, read)
			setLessons(read)
		})
		// la chiave dice già circolo e stagione
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [key])

	return lessons
}

export default useSeasonRecoveryLessons
